import React from "react";
import logo from "../images/logo.png";

const SiteEnConstruction = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #fffaf5 0%, #fff3f8 45%, #fff8ef 100%)",
        padding: "2rem",
      }}
    >
      <div
        style={{
          maxWidth: "720px",
          width: "100%",
          background: "#ffffff",
          borderRadius: "28px",
          boxShadow: "0 24px 60px rgba(17, 24, 39, 0.08)",
          border: "1px solid rgba(255, 117, 0, 0.12)",
          padding: "2.5rem 2rem",
          textAlign: "center",
        }}
      >
        <img
          src={logo}
          alt="Vivacrea"
          style={{
            width: "240px",
            maxWidth: "100%",
            height: "auto",
            display: "block",
            margin: "0 auto 1.5rem",
          }}
        />

        <div
          style={{
            display: "inline-block",
            backgroundColor: "var(--accent-primary-soft)",
            color: "var(--accent-primary)",
            border: "1px solid rgba(255, 117, 0, 0.25)",
            borderRadius: "999px",
            padding: "0.55rem 1rem",
            fontSize: "0.75rem",
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            fontWeight: 700,
            marginBottom: "1rem",
          }}
        >
          Maintenance
        </div>

        <h1
          style={{
            margin: "0 0 0.75rem",
            color: "#111827",
            fontSize: "clamp(2.2rem, 4vw, 3.5rem)",
            lineHeight: 1.15,
            fontFamily: "Fraunces, serif",
          }}
        >
          Site en construction
        </h1>

        <p
          style={{
            margin: "0 auto",
            maxWidth: "520px",
            color: "#4b5563",
            fontSize: "1.05rem",
            lineHeight: 1.75,
          }}
        >
          Nous préparons la prochaine version de Vivacrea. Revenez très bientôt pour découvrir nos services et nos créateurs.
        </p>

      </div>
    </div>
  );
};

export default SiteEnConstruction;
